"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActiveToolContextProvider = exports.ActiveToolContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var ActiveToolContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.ActiveToolContext = ActiveToolContext;

var ActiveToolContextProvider = function ActiveToolContextProvider(_ref) {
  var children = _ref.children,
      defaultActiveTool = _ref.defaultActiveTool,
      linkDialogRef = _ref.linkDialogRef;

  var _useState = (0, _react.useState)(defaultActiveTool),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeTool = _useState2[0],
      setActiveTool = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(ActiveToolContext.Provider, {
    value: {
      activeTool: activeTool,
      setActiveTool: setActiveTool,
      linkDialogRef: linkDialogRef
    }
  }, children);
};

exports.ActiveToolContextProvider = ActiveToolContextProvider;
//# sourceMappingURL=contexts.js.map